import { useContext, useMemo, useState } from "react";
import OverflowingComponentsContext from "views/components/contexts/OverflowingComponentsContext";
const useOverflowingComponents = () => {
  const [selfOverflowingComponents, setSelfOverflowingComponents] = useState({});
  const context = useContext(OverflowingComponentsContext);
  const overflowingComponents = useMemo(
    () => {
      var _a;
      return (_a = context == null ? void 0 : context.overflowingComponents) != null ? _a : selfOverflowingComponents;
    },
    [context == null ? void 0 : context.overflowingComponents, selfOverflowingComponents]
  );
  const setOverflowingComponents = useMemo(
    () => {
      var _a;
      return (_a = context == null ? void 0 : context.setOverflowingComponents) != null ? _a : setSelfOverflowingComponents;
    },
    [context == null ? void 0 : context.setOverflowingComponents]
  );
  return { isFromContext: !!context, overflowingComponents, setOverflowingComponents };
};
export default useOverflowingComponents;
